import { inject, Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Observable } from 'rxjs';
import { StorageInterface } from '../storage.interface';

@Injectable({ providedIn: 'root' })
export class LocalService implements StorageInterface {
  private readonly storage = inject(LocalStorageService);

  public set<T>(key: string, value: T): void {
    this.storage.store(key, value);
  }

  public get<T>(key: string): T | null {
    return this.storage.retrieve(key) as T | null;
  }

  public remove(key: string): void {
    this.storage.clear(key);
  }

  public observe<T>(key: string): Observable<T> {
    return this.storage.observe(key) as Observable<T>;
  }
}
